module.exports = __webpack_public_path__ + "media/images/homes/Untitled-5-ff7a4ef647c66cac7b04e4be2b33785d.svg";